import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { formatDateSafe } from '@/utils/dateUtils';
import { CARD_LABELS } from '../vacationApprovalCard.definitions';
import type { ApprovalConflictNoticeProps } from '../vacationApprovalCard.types';
import { getConflictRanges } from '../../../utils/allocationConflictDays';

export function ApprovalConflictNotice({ conflicts, segments }: ApprovalConflictNoticeProps) {
    if (conflicts.length === 0) return null;

    return (
        <div className="rounded-xl border border-amber-200 bg-amber-50 p-3">
            <div className="flex items-center gap-2">
                <ExclamationTriangleIcon
                    className="h-4 w-4 shrink-0 text-amber-600"
                    aria-hidden="true"
                />
                <p className="text-xs font-semibold text-amber-900 font-montserrat">
                    {CARD_LABELS.conflictsTitle}
                    {conflicts.length > 1 ? ` (${conflicts.length})` : ''}
                </p>
            </div>

            <ul className="mt-2 space-y-1">
                {conflicts.map((conflict) => {
                    const ranges = segments ? getConflictRanges(segments, conflict) : [];
                    const hasRanges = ranges.length > 0;

                    let datesText: string;
                    if (hasRanges) {
                        const formattedRanges = ranges.map(r => {
                            const start = formatDateSafe(r.start);
                            const end = formatDateSafe(r.end);
                            return start === end ? start : `${start} a ${end}`;
                        });
                        const totalDays = ranges.reduce((sum, r) => sum + r.days, 0);
                        datesText = `${formattedRanges.join(' e ')} · ${totalDays} dias`;
                    } else {
                        datesText = `${formatDateSafe(conflict.startDate)}${conflict.endDate ? ` a ${formatDateSafe(conflict.endDate)}` : ' em diante'}`;
                    }

                    return (
                        <li
                            key={conflict.allocationId}
                            className="text-xs text-amber-900 font-montserrat"
                        >
                            <span className="font-medium">
                                {conflict.clientName ?? 'Cliente não informado'}
                            </span>
                            {conflict.projectName ? ` · ${conflict.projectName}` : ''}
                            <span className="text-amber-700">
                                {' '}
                                — {datesText}
                            </span>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

export default ApprovalConflictNotice;
